
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-science-live-course",
      function () {
        return require("private-next-pages/data-science-live-course.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-science-live-course"])
      });
    }
  